import React from 'react'

const moneyRoutes = [
    {
        path: '/money/fiscal',
        component: React.lazy(() => import('./fiscal/FiscalPage')),
        accessPageName: 'FISCAL_VIEW',
    },
    {
        path: '/money/cashbox',
        component: React.lazy(() => import('./cashbox/cashbox')),
        exact: true,
        accessPageName: 'CASHBOXX',
    },
    {
        path: '/money/cashbox/history',
        component: React.lazy(() => import('./cashbox/CashboxShiftHistory')),
        exact: true,
        accessPageName: 'CASHBOXX',
    },

]

export default moneyRoutes
